import { CloudRenderingRegion } from "@/hooks/types";

export function sortRegions(a: CloudRenderingRegion, b: CloudRenderingRegion) {
  // A distance the backend omitted entirely counts as unknown, just like an
  // explicit null - otherwise both would be treated as known here and compared
  // as `undefined - undefined`, i.e. NaN.
  // If both have a known distance, sort by distance
  if (a.distanceM != null && b.distanceM != null) {
    return a.distanceM - b.distanceM;
  }
  // If only a has a known distance, it comes first
  if (a.distanceM != null) return -1;
  // If only b has a known distance, it comes first
  if (b.distanceM != null) return 1;
  // Neither distance is known, maintain order
  return 0;
}
